export const THEME_LABELS = {
  Nature: "Doğa",
  History: "Tarih",
  Food: "Yemek",
  Adventure: "Macera",
  Sea: "Deniz",
  Culture: "Kültür",
};

export const SEASON_LABELS = {
  Spring: "İlkbahar",
  Summer: "Yaz",
  Autumn: "Sonbahar",
  Winter: "Kış",
  All: "Tüm sezonlar",
};

export const CATEGORY_LABELS = {
  hotel: "Otel",
  resort: "Tatil Köyü",
  pension: "Pansiyon",
  restaurant: "Restoran",
  agency: "Tur Ajansı",
  souvenir: "Hediyelik",
  transport: "Ulaşım",
  guide: "Rehber",
};

export const ROLE_LABELS = {
  admin: "Yönetici",
  business: "İşletme",
  agency: "Acente",
  guide: "Rehber",
  customer: "Kullanıcı",
};

export const BOOKING_STATUS_LABELS = {
  pending: "Bekliyor",
  confirmed: "Onaylandı",
  cancelled: "İptal",
};

export const SUBSCRIPTION_STATUS_LABELS = {
  active: "Aktif",
  cancelled: "İptal",
  expired: "Süresi dolmuş",
};

export const PAYMENT_PLAN_LABELS = {
  "basic-monthly": "Temel Aylık",
  "pro-monthly": "Pro Aylık",
  "pro-yearly": "Pro Yıllık",
};

export const PAYMENT_STATUS_LABELS = {
  completed: "Tamamlandı",
  pending: "Bekliyor",
  failed: "Başarısız",
  refunded: "İade edildi",
};

export const SUPPORT_CATEGORY_LABELS = {
  account: "Hesap",
  technical: "Teknik",
  booking: "Rezervasyon",
  privacy: "Gizlilik",
  feedback: "Geri bildirim",
  other: "Diğer",
};

export const SUPPORT_STATUS_LABELS = {
  open: "Açık",
  in_progress: "İşlemde",
  resolved: "Çözüldü",
  closed: "Kapatıldı",
};

export function themeLabel(theme) {
  return THEME_LABELS[theme] || theme;
}

export function seasonLabel(season) {
  return SEASON_LABELS[season] || season;
}

export function categoryLabel(category) {
  return CATEGORY_LABELS[category] || category;
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}

export function bookingStatusLabel(status) {
  return BOOKING_STATUS_LABELS[status] || status;
}

export function subscriptionStatusLabel(status) {
  return SUBSCRIPTION_STATUS_LABELS[status] || status;
}

export function paymentPlanLabel(planId) {
  return PAYMENT_PLAN_LABELS[planId] || planId;
}

export function paymentStatusLabel(status) {
  return PAYMENT_STATUS_LABELS[status] || status;
}

export function supportCategoryLabel(category) {
  return SUPPORT_CATEGORY_LABELS[category] || category;
}

export function supportStatusLabel(status) {
  return SUPPORT_STATUS_LABELS[status] || status;
}
